import React, { useState } from 'react';
import api from '../services/api';

const NovoAgendamento = () => {
  const [form, setForm] = useState({
    data: '', hora_inicio: '09:00', duracao_minutos: 30, paciente: '', telefone: '', tipo: 'Primeira Consulta', observacoes: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/ia/agendar', form);
      alert('Agendamento confirmado com sucesso.');
      setForm({...form, paciente: '', telefone: '', observacoes: ''});
    } catch (err) {
      alert('Erro ao criar agendamento.');
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div>
            <h2 style={styles.title}>Novo Agendamento</h2>
            <p style={styles.subtitle}>Registro interno de pacientes</p>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.row}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Data da Consulta</label>
              <input type="date" required value={form.data} onChange={e => setForm({...form, data: e.target.value})} style={styles.input} />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Horário</label>
              <input type="time" required value={form.hora_inicio} onChange={e => setForm({...form, hora_inicio: e.target.value})} style={styles.input} />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Duração (min)</label>
              <input type="number" required value={form.duracao_minutos} onChange={e => setForm({...form, duracao_minutos: parseInt(e.target.value)})} style={styles.input} />
            </div>
          </div>

          <div style={styles.row}>
            <div style={{...styles.inputGroup, flex: 2}}>
              <label style={styles.label}>Nome do Paciente</label>
              <input type="text" required placeholder="Ex: Maria Eduarda" value={form.paciente} onChange={e => setForm({...form, paciente: e.target.value})} style={styles.input} />
            </div>
            <div style={{...styles.inputGroup, flex: 1}}>
              <label style={styles.label}>WhatsApp</label>
              <input type="text" required placeholder="(11) 90000-0000" value={form.telefone} onChange={e => setForm({...form, telefone: e.target.value})} style={styles.input} />
            </div>
          </div>
          
          <div style={styles.inputGroup}>
            <label style={styles.label}>Procedimento</label>
            <select value={form.tipo} onChange={e => setForm({...form, tipo: e.target.value})} style={styles.select}>
              <option value="Primeira Consulta">Primeira Consulta</option>
              <option value="Retorno">Retorno</option>
              <option value="Procedimento">Procedimento Estético</option>
            </select>
          </div>
          
          <div style={styles.inputGroup}>
            <label style={styles.label}>Observações Particulares</label>
            <textarea placeholder="Detalhes sobre a queixa ou histórico..." value={form.observacoes} onChange={e => setForm({...form, observacoes: e.target.value})} style={styles.textarea} />
          </div>
          
          <button type="submit" style={styles.button}>Confirmar Reserva</button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  page: { display: 'flex', justifyContent: 'center', padding: '40px 20px', fontFamily: '"Montserrat", "Inter", sans-serif', backgroundColor: '#FAF8F5', minHeight: '100vh' },
  card: { backgroundColor: '#FFFFFF', borderRadius: '12px', padding: '40px', width: '100%', maxWidth: '650px', boxShadow: '0 15px 35px rgba(181, 153, 120, 0.08)', border: '1px solid #EBE6E0' },
  header: { marginBottom: '32px', textAlign: 'center', borderBottom: '1px solid #EBE6E0', paddingBottom: '20px' },
  title: { margin: 0, fontSize: '26px', color: '#2C2A29', fontFamily: '"Playfair Display", serif', fontWeight: '500', letterSpacing: '0.5px' },
  subtitle: { margin: '6px 0 0 0', fontSize: '13px', color: '#7A7571', textTransform: 'uppercase', letterSpacing: '1px' },
  form: { display: 'flex', flexDirection: 'column', gap: '24px' },
  row: { display: 'flex', gap: '20px', flexWrap: 'wrap' },
  inputGroup: { display: 'flex', flexDirection: 'column', flex: 1, minWidth: '130px' },
  label: { fontSize: '12px', fontWeight: '500', color: '#7A7571', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  input: { padding: '14px', borderRadius: '8px', border: '1px solid #EBE6E0', fontSize: '14px', color: '#2C2A29', outline: 'none', backgroundColor: '#FCFBF9', transition: 'border-color 0.3s' },
  select: { padding: '14px', borderRadius: '8px', border: '1px solid #EBE6E0', fontSize: '14px', color: '#2C2A29', backgroundColor: '#FCFBF9', outline: 'none', cursor: 'pointer' },
  textarea: { padding: '14px', borderRadius: '8px', border: '1px solid #EBE6E0', fontSize: '14px', color: '#2C2A29', minHeight: '100px', backgroundColor: '#FCFBF9', outline: 'none', resize: 'vertical' },
  button: { marginTop: '10px', padding: '16px', backgroundColor: '#B59978', color: '#FFFFFF', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1px', cursor: 'pointer', transition: 'background-color 0.3s' }
};

export default NovoAgendamento;